import servise from '@/router/axios'

export const getRtbCreativeList = (params) => {
  return servise({
    url: '/rtbCreative/list',
    method: 'get',
    params
  })
}

export const getRtbCreativeById = (ideaId) => {
  return servise({
    url: `/rtbCreative/${ideaId}`,
    method: 'get'
  })
}

export const updateRtbCreative = (data) => {
  return servise({
    url: '/rtbCreative/update',
    method: 'put',
    data
  })
}

export const queryKuaishouAudit = (ideaIds) => {
  return servise({
    url: '/rtbCreative/queryKuaishouAudit',
    method: 'post',
    data: ideaIds
  })
}

export const updateKuaishouCreative = (ideaId) => {
  return servise({
    url: '/rtbCreative/updateKuaishouCreative',
    method: 'post',
    params: { ideaId }
  })
}

export const submitKuaishouCreative = (ideaId) => {
  return servise({
    url: '/rtbCreative/submitKuaishouCreative',
    method: 'post',
    params: { ideaId }
  })
}